<template>
  <div
    :class="isActive ? 'cardButtonOnClick' : 'cardButton'"
    @click="onCallFunc"
  >
    <h3>{{ title }}</h3>
    <p>{{ description }}</p>
    <div class="cardButton-price-button">
      <p>{{ price }}</p>
      <button class="btn btn-outline-primary btn-sm">{{ buttonText }}</button>
    </div>
    <ul>
      <li v-for="(feature, index) in features" :key="index">
        <i class="fa fa-check" aria-hidden="true"></i> {{ feature }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "CardButton",
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    price: {
      type: String,
      required: true
    },
    buttonText: {
      type: String,
      default: "Current Plan"
    },
    features: {
      type: Array,
      default: () => []
    },
    isActive: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentButtonState: ""
    };
  },
  computed: {},
  methods: {
    onCallFunc() {
      this.$emit("onCallFunc");
    }
  },
  async mounted() {
    console.log("isActive", isActive);
  }
};
</script>

<style lang="scss" scoped>
.cardButton {
  border: 1px solid grey;
  cursor: pointer;
  padding-left: 18px;
  width: 100%;
  margin-bottom: 28px;
  min-height: 330px;
  max-height: 340px;
  h3 {
    color: #1a93ca;
    font-weight: 520;
    font-size: 21px;
  }
  p {
    color: rgba(73, 80, 80, 0.986);
    font-size: 16px;
    margin: 6px 0 24px 0;
  }
}

.cardButton:hover {
  border: 2px solid #1a93ca;
  box-shadow: 2px 2px #888888;
  cursor: pointer;
  padding-left: 18px;
  width: 100%;
  margin-bottom: 28px;
  min-height: 330px;
  max-height: 340px;
  h3 {
    color: #1a93ca;
    font-weight: 520;
    font-size: 21px;
  }
  p {
    color: rgba(73, 80, 80, 0.986);
    font-size: 16px;
    margin: 6px 0 24px 0;
  }
}

.cardButtonOnClick {
  border: 2px solid #1a93ca;
  box-shadow: 2px 2px #888888;
  cursor: pointer;
  padding-left: 18px;
  width: 100%;
  margin-bottom: 28px;
  min-height: 330px;
  max-height: 340px;
  h3 {
    color: #1a93ca;
    font-weight: 520;
    font-size: 21px;
  }
  p {
    color: rgba(73, 80, 80, 0.986);
    font-size: 16px;
    margin: 6px 0 24px 0;
  }
}

.cardButton-price-button {
  width: 50%;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  margin-top: 40px;
  margin-bottom: 40px;
  p {
    color: darkslategrey;
    font-size: 17px;
    font-weight: 600;
    margin: 6px 0 24px 0;
  }
}

ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  li {
    font-size: 13.5px;
    color: darkslategrey;
  }
}
.content-area {
  background-color: #f5f6f8 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/section-manager/layout/CardButton.vue